import React from "react";

export function SelectionHintTooltip() {
  return (
    <div
      style={{
        position: "absolute",
        bottom: "calc(100% + 10px)",
        right: 0,
        backgroundColor: "#1a1a1a",
        borderRadius: "10px",
        padding: "10px 10px 8px",
        boxShadow: "0 8px 30px rgba(0,0,0,0.3)",
        zIndex: 1000,
        pointerEvents: "none",
        animation: "hint-fade-in 0.15s ease",
      }}
    >
      <style>{`
        @keyframes hint-fade-in {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes hint-cursor {
          0%, 12% { transform: translate(18px, 10px); opacity: 1; }
          45%, 70% { transform: translate(85px, 48px); opacity: 1; }
          85%, 100% { transform: translate(85px, 48px); opacity: 0; }
        }
        @keyframes hint-highlight {
          0%, 42% { stroke: rgba(255,255,255,0.25); }
          50%, 70% { stroke: #4d90fe; }
          85%, 100% { stroke: rgba(255,255,255,0.25); }
        }
      `}</style>

      <svg
        width="180"
        height="60"
        viewBox="0 0 180 60"
        style={{
          backgroundColor: "#2a2a2a",
          borderRadius: 6,
          display: "block",
          margin: "0 auto",
        }}
      >
        {/* Scribble shapes */}
        <path
          d="M45 18 Q52 10 60 20 Q68 32 56 37"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          style={{ animation: "hint-highlight 3.5s ease infinite" }}
        />
        <path
          d="M72 15 L82 34 L62 34 Z"
          fill="none"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ animation: "hint-highlight 3.5s ease infinite" }}
        />
        <circle
          cx="50"
          cy="42"
          r="6"
          fill="none"
          strokeWidth="1.5"
          style={{ animation: "hint-highlight 3.5s ease infinite" }}
        />

        {/* Selection rectangle that grows as cursor drags */}
        <rect
          x="18"
          y="10"
          rx="2"
          ry="2"
          fill="rgba(77,144,254,0.06)"
          stroke="#4d90fe"
          strokeWidth="1.5"
          strokeDasharray="4 3"
        >
          <animate
            attributeName="width"
            values="0;0;67;67;67;0"
            keyTimes="0;0.12;0.45;0.70;0.85;1"
            dur="3.5s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="height"
            values="0;0;38;38;38;0"
            keyTimes="0;0.12;0.45;0.70;0.85;1"
            dur="3.5s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="opacity"
            values="0;0;1;1;1;0"
            keyTimes="0;0.11;0.12;0.70;0.85;1"
            dur="3.5s"
            repeatCount="indefinite"
          />
        </rect>

        {/* Animated cursor */}
        <g style={{ animation: "hint-cursor 3.5s ease infinite" }}>
          <path
            d="M0 0 L0 12 L3.5 8.5 L6.5 14 L8 13 L5 7.5 L9 7.5 Z"
            fill="white"
            stroke="#333"
            strokeWidth="0.5"
          />
        </g>
      </svg>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 4,
          marginTop: 8,
          fontSize: 10,
          color: "#999",
          fontWeight: 500,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 14,
            height: 14,
            borderRadius: 3,
            backgroundColor: "#333",
            color: "#fff",
            fontSize: 8,
            fontWeight: 700,
            flexShrink: 0,
          }}>1</span>
          <span style={{ display: "inline-flex", alignItems: "center", gap: 3 }}>Click
            <svg width="8" height="10" viewBox="0 0 11 16" style={{ flexShrink: 0 }}>
              <path d="M0 0 L0 14 L4 10 L7.5 16 L9.5 15 L6 9 L11 9 Z" fill="#999" />
            </svg>
            in toolbar
          </span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 5 }}>
          <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 14,
            height: 14,
            borderRadius: 3,
            backgroundColor: "#333",
            color: "#fff",
            fontSize: 8,
            fontWeight: 700,
            flexShrink: 0,
          }}>2</span>
          <span>Select your drawing</span>
        </div>
      </div>

      {/* Tooltip arrow pointing down */}
      <div
        style={{
          position: "absolute",
          bottom: -5,
          right: 10,
          transform: "rotate(45deg)",
          width: 10,
          height: 10,
          backgroundColor: "#1a1a1a",
        }}
      />
    </div>
  );
}
